/**
 * @generated SignedSource<<a2e76296b094d113d3b2c46bdb32cd5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AssignClientAssetApproverInput = {
  projectId: string;
  assetId: string;
  approverPortalUserId: string;
  dueDate?: string | null;
  reason?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type clientAssetMutationsAssignApproverMutation$variables = {
  input: AssignClientAssetApproverInput;
};
export type clientAssetMutationsAssignApproverMutation$data = {
  readonly assignClientAssetApprover: {
    readonly asset: {
      readonly id: string;
      readonly status: string;
      readonly dueDate: string | null;
      readonly approverPortalUserId: string | null;
      readonly approverEmail: string | null;
    } | null;
  } | null;
};
export type clientAssetMutationsAssignApproverMutation = {
  variables: clientAssetMutationsAssignApproverMutation$variables;
  response: clientAssetMutationsAssignApproverMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AssignClientAssetApproverPayload",
    "kind": "LinkedField",
    "name": "assignClientAssetApprover",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientAsset",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approverPortalUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approverEmail",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "clientAssetMutationsAssignApproverMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "clientAssetMutationsAssignApproverMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cf350dc4fe61b7b428e78df472efa2a6",
    "id": null,
    "metadata": {},
    "name": "clientAssetMutationsAssignApproverMutation",
    "operationKind": "mutation",
    "text": "mutation clientAssetMutationsAssignApproverMutation(\n  $input: AssignClientAssetApproverInput!\n) {\n  assignClientAssetApprover(input: $input) {\n    asset {\n      id\n      status\n      dueDate\n      approverPortalUserId\n      approverEmail\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "778985c86961128a8ea09e6f04b6c948";

export default node;
